import React from 'react';
import { Image } from 'react-native';

const IconBeerII = ({ active }) => {
  const img = active
    ? require('../../../assets/stdunits/beerII.png')
    : require('../../../assets/stdunits/beerII_grey.png');

  return <Image style={{ height: 100, width: 43 }} source={img} />;
};

export { IconBeerII };
